import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api, { API_ROOT_URL } from '../../api';
import axios from 'axios';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/products/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/products/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/products/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadProductsByCategory(params, query) {
  const category = params.subcategory || params.category;
  const page = query.page;
  const sort = query.sort;
  return {
    [RSAA]: {
      ...api.getProductsByCategory(category, page, sort),
      types: [
        LOAD_REQUEST,
        LOAD_SUCCESS,
        {
          type: LOAD_FAILURE,
          payload: async (action, state, res) => {
            // se non trova la categoria allora cerca un possibile redirect
            try {
              res = await res.json();
              const storeid = state.store.data.storeId;

              if (res.statusCode === 404) {
                const paths = [
                  params.category.split('-')[0],
                  params.category,
                  params.subcategory,
                ];

                const url = '/' + paths.filter(path => !!path).join('/');
                let config = {
                  method: 'GET',
                  url: `${API_ROOT_URL}/store/redirect?url=${url}`,
                  headers: {
                    storeid,
                  },
                };

                const response = await axios(config);

                // se restituisce pagina non trovata allora non fa il redirect
                if (response.data !== '/pagina-non-trovata') {
                  return {
                    message: 'Redirecting...',
                    redirect: response.data,
                  };
                } else {
                  return {
                    message: 'Redirect not found',
                  };
                }
              } else {
                return {
                  message: res.message,
                };
              }
            } catch (error) {
              return {
                message: error.message,
              };
            }
          },
        },
      ],
    },
  };
}

// TODO: sembra non andare con varnish in locale funziona
// export function loadProductsByCategory(params, query) {
//   const category = params.subcategory || params.category;
//   const page = query.page;
//   const sort = query.sort;
//   return function(dispatch, getState) {
//     const { endpoint, method, headers } = api.getProductsByCategory(
//       category,
//       page,
//       sort
//     );

//     const storeid = getState().store.data.storeId;

//     const headersWithStoreId = {
//       ...headers,
//       storeid,
//     };

//     dispatch({ type: LOAD_REQUEST });

//     fetch(endpoint, { method, headers: headersWithStoreId })
//       .then(response => response.json())
//       .then(json => {
//         if (json.error) {
//           throw new Error(json.error);
//         }
//         dispatch({
//           type: LOAD_SUCCESS,
//           payload: json,
//         });
//       })
//       .catch(error => {
//         // se non trova prodotti allora cerca un possibile redirect
//         if (error.message === 'Not Found') {
//           const paths = [
//             params.category.split('-')[0],
//             params.category,
//             params.subcategory,
//           ];
//           const url = '/' + paths.filter(path => !!path).join('/');

//           let config = {
//             method: 'GET',
//             url: `${API_ROOT_URL}/store/redirect?url=${url}`,
//             headers: {
//               storeid,
//             },
//           };
//           axios
//             .request(config)
//             .then(res => {
//               // se restituisce pagina non trovata allora non fa il redirect
//               if (res.data !== '/pagina-non-trovata') {
//                 dispatch({
//                   type: LOAD_FAILURE,
//                   payload: {
//                     message: error.message,
//                     redirect: res.data,
//                   },
//                 });
//               } else {
//                 dispatch({
//                   type: LOAD_FAILURE,
//                   payload: {
//                     message: error.message,
//                   },
//                 });
//               }
//             })
//             .catch(error => {
//               dispatch({
//                 type: LOAD_FAILURE,
//                 payload: {
//                   message: error.message,
//                 },
//               });
//             });
//         } else {
//           dispatch({
//             type: LOAD_FAILURE,
//             payload: {
//               message: error.message,
//             },
//           });
//         }
//       });
//   };
// }

// API CALL
export function loadProductsByKeywords(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByKeywords(params.keywords, query.page, query.pageSize),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsByTag(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByTag(
        params.tag,
        query.page,
        query.pageSize,
        query.sort
      ),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsDiscounted(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsDiscounted(query.page, query.pageSize, query.sort),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  redirect: null,
  error: '',
  data: [],
  pagination: {
    page: 1,
    totalPages: 1,
  },
};

export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        redirect: null,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.items,
        pagination: action.payload.pagination,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        redirect: action.payload.redirect,
      };
    default:
      return state;
  }
}
